const localeTexts = {
  404: {
    title: "404: Not Found",
    body: "The link you tried to access doesn't seem to exist. <br /> Please verify and enter the correct URL.",
    button: {
      learnMore: "Learn more",
    },
  },
  AssetSidebarWidget: {
    title: "Asset Sidebar Widget",
    body: "This is the iframe that contains your asset sidebar widget <br /> Build you app now",
    button: {
      learnMore: "Learn more",
    },
  },
  ConfigScreen: {
    title: "App Configuration",
    body: "This is the iframe that contains your app configuration <br /> Build you app now",
    button: {
      learnMore: "Learn more",
    },
  },
  CustomField: {
    title: "Custom Field",
    body: "This is the iframe that contains your custom field <br /> Build you app now",
    button: {
      learnMore: "Learn more",
    },
  },
  EntryField: {
    title: "Entry Field",
    body: "This is the iframe that contains your entry field <br /> Build you app now",
    button: {
      learnMore: "Learn more",
    },
  },
  DashboardWidget: {
    title: "Dashboard Widget",
    body: "This is the iframe that contains your dashboard widget <br /> Build you app now",
    button: {
      learnMore: "Learn more",
    },
  },
  SidebarWidget: {
    title: "Sidebar Widget",
    body: "This is the iframe that contains your entry sidebar widget <br /> Build you app now",
    button: {
      learnMore: "Learn more",
    },
  },
};

export default localeTexts;
